import { CLOUD_LAUNCH_PROMO } from '@/data/cloud';
const en = {
  m000: "GizmoData Cloud Is Generally Available: Fully Managed DuckDB on AWS, Google Cloud and Azure",
  m001: "GizmoData Cloud, fully managed GizmoSQL, is now open to everyone at app.gizmodata.com. Launch DuckDB-powered Arrow Flight SQL clusters, DuckLake catalogs and federated queries on AWS, Google Cloud and Azure from one control plane, on prepaid plans from $29/month that come back in full as compute credit. Start free with $25 of launch credit, applied automatically, no credit card.",
  m002: "AWS, Google Cloud & Azure",
  m003: "DuckLake Catalogs",
  m004: "Federated Queries (14 ADBC Drivers)",
  m005: "$25 Launch Credit, No Card",
  m006: "GizmoSQL v1.39.0: Prometheus Metrics and Eager DDL/DML Execution",
  m007: "GizmoSQL v1.39.0 adds Enterprise Prometheus metrics — an opt-in /metrics endpoint and a gizmosql_metrics() SQL function covering queries, sessions, queues, and process resources, with a ready-made Grafana dashboard and alert rules. DDL and DML now execute when a client requests execution, so a write is never lost when a driver skips fetching its result. Plus INFO-level bulk ingest logging and narrower server locking for higher concurrency.",
  m008: "Prometheus /metrics Endpoint",
  m009: "gizmosql_metrics() SQL Monitoring",
  m010: "Grafana Dashboard & Alerts",
  m011: "Eager DDL/DML Execution",
  m012: "Chris Wones Joins GizmoData as Strategic Advisor",
  m013: "Chris Wones, a 34-year enterprise data and engineering leader whose career spans James River, Retek, dunnhumby, and Kroger/84.51°, has joined GizmoData as Strategic Advisor. He brings the buyer’s-side view of enterprise data platforms to GizmoSQL and GizmoData Cloud.",
  m014: "34 Years in Enterprise Data",
  m015: "Oracle Big Data Leader of the Year",
  m016: "Former Engineering Executive",
  m017: "Kroger / 84.51° & dunnhumby",
  m018: "GizmoSQL MCP Server: Query GizmoSQL from Claude Desktop & Claude Code",
  m019: "We shipped gizmosql-mcp, a Model Context Protocol server and Claude Desktop extension for GizmoSQL. Claude Desktop, Claude Code, and any MCP client can explore your schema and run SQL against a GizmoSQL server — read-only by default, with server-enforced row caps and timeouts, credentials kept in your OS keychain, and support for several servers in one conversation. Free, Apache-2.0.",
  m020: "Claude Desktop Extension",
  m021: "Claude Code Ready",
  m022: "Read-Only by Default",
  m023: "Multi-Server",
  m024: "The GizmoData ADBC Driver Suite: Oracle, Db2, GizmoSQL & Quack",
  m025: "We shipped pure-Go, pip-installable ADBC drivers for Oracle (no Instant Client), IBM Db2 (no CLI/JCC), and DuckDB's Quack — alongside our flagship GizmoSQL driver. Because they're all Apache Arrow-native, moving a table from Oracle or Db2 into GizmoSQL is a few lines of Python, or a single SQL statement from DuckDB — bidirectionally.",
  m026: "Pure Go, pip install",
  m027: "No Instant Client / CLI / JCC",
  m028: "Oracle & Db2 ↔ GizmoSQL",
  m029: "Bidirectional via adbc_scanner",
  m030: "GizmoSQL ADBC Driver 2.0: Go-Powered Core, Every ADBC Language",
  m031: "The GizmoSQL ADBC driver is rebuilt in Go with a thin Python wrapper that stays drop-in compatible with 1.x. OAuth/SSO, automatic DDL/DML detection, and the rest of the GizmoSQL goodies now reach Python, Go, R, Rust, C#, C/C++, and JavaScript — and the whole client ecosystem (dbt, SQLMesh, qgizmosql, sqlframe, the Node.js client behind GizmoSQL UI) has been updated to match.",
  m032: "Go-Powered Core",
  m033: "Drop-In Python 2.0",
  m034: "OAuth / SSO Everywhere",
  m035: "7 Languages, 1 Driver",
  m036: "GizmoSQL v1.34.0: Upgraded to Apache Arrow 25",
  m037: "GizmoSQL v1.34.0 jumps two Apache Arrow releases to v25.0.0 — bringing Flight SQL protocol groundwork, stricter IPC validation, Arrow's new formal security model, a refreshed gRPC/protobuf stack, and ARM64 SVE speedups on Graviton. Plus a full per-query execution timeline in Enterprise instrumentation.",
  m038: "Apache Arrow 25.0.0",
  m039: "Hardened Wire Format",
  m040: "ARM64 SVE Speedups",
  m041: "Full Query Timeline",
  m042: "Python ADBC Driver v1.2.0: Connection Profiles",
  m043: "adbc-driver-gizmosql v1.2.0 adds support for ADBC connection profiles — reusable TOML files that bundle your GizmoSQL server URI and options, with environment-variable substitution keeping credentials out of your code. Switch between dev and prod by changing one profile name.",
  m044: "TOML Profiles",
  m045: "Env-Var Secrets",
  m046: "profile:// URIs",
  m047: "Cross-Language Standard",
  m048: "Join the New GizmoData Community on Slack",
  m049: "GizmoData just launched a community Slack where GizmoSQL users can talk directly with the founder, swap tips on running DuckDB as an Apache Arrow Flight SQL server, get help, and hear about new releases first. Free to join — everyone welcome.",
  m050: "Talk to the Founder",
  m051: "Get Help",
  m052: "Release News",
  m053: "Free to Join",
  m054: "Philip Moore on the A/I Prosperity Podcast",
  m055: "GizmoData founder Philip Moore joined Torben Andersen on the A/I Prosperity podcast for a wide-ranging conversation on GizmoSQL, running DuckDB as an enterprise-grade Apache Arrow Flight SQL server, and cutting cloud data-warehouse costs.",
  m056: "Philip Moore",
  m057: "GizmoSQL Is Now a Built-In DBeaver Driver",
  m058: "As of the 26.1.0 release, GizmoSQL ships as a native driver in DBeaver — the world's most popular database GUI. No manual JDBC setup: pick GizmoSQL from the driver list, enter your connection, and start querying. Bundled and maintained upstream.",
  m059: "Built-In Driver",
  m060: "DBeaver 26.1.0+",
  m061: "Zero JDBC Setup",
  m062: "Arrow Flight SQL",
  m063: "Experimental Quack JDBC Driver",
  m064: "A new JDBC driver for the Quack remote protocol — point any JVM tool (DBeaver, DataGrip, dbt, Spark) at a jdbc:quack:// URL and start querying a remote DuckDB server. Distributed on Maven Central. Experimental/alpha.",
  m065: "jdbc:quack:// URLs",
  m066: "JVM Tool Compatible",
  m067: "DataChunk Decoding",
  m068: "Maven & Direct JAR",
  m069: "Experimental ADBC Driver for Quack",
  m070: "A new Apache Arrow ADBC driver for the Quack remote protocol — zero-copy Arrow RecordBatches straight from a remote DuckDB server. Available for Python (PyPI) and Go (pkg.go.dev), with streaming and bulk-ingest support. Experimental/alpha.",
  m071: "Zero-Copy Arrow",
  m072: "Python & Go",
  m073: "Bulk Ingest",
  m074: "Streaming Results",
  m075: "GizmoSQL Now Has a Python Library",
  m076: "Spin up a real GizmoSQL server from Python in two lines — perfect for pytest fixtures, multi-agent workflows, and notebook demos. The library manages a server subprocess on a free port and downloads the matching binary on first use. Install with `pip install gizmosql[adbc]`.",
  m077: "pip install gizmosql[adbc]",
  m078: "Server() Context Manager",
  m079: "pytest Fixture Ready",
  m080: "Stable & LTS Channels",
  m081: "Introducing the GizmoSQL LTS Channel",
  m082: "GizmoSQL now ships in two parallel release channels — Stable (latest DuckDB minor) and LTS (most recent DuckDB LTS) — for production deployments that need a slower-moving, longer-supported engine. Same GizmoSQL features, same protocol, side-by-side installs.",
  m083: "Tracks DuckDB LTS Releases",
  m084: "Stable & LTS Side-by-Side",
  m085: "Identical GizmoSQL API",
  m086: "Homebrew, Docker & MSI",
  m087: "qgizmosql: New QGIS Plugin for GizmoSQL",
  m088: "Browse and visualize spatial data from a GizmoSQL server directly in QGIS. Connect to a remote (or local) GizmoSQL Arrow Flight SQL service, pick a table, and add it as a QGIS layer — no raw DuckDB file required.",
  m089: "Arrow Flight SQL Transport",
  m090: "Remote & Multi-User",
  m091: "Password or OAuth/SSO",
  m092: "Server-Side Spatial Engine",
  m093: "GizmoSQL Now Available on the Apple App Store",
  m094: "GizmoSQL is now on the Apple App Store for iPhone and iPad. Spin up a real Arrow Flight SQL server right from your pocket — perfect for development, experimentation, and learning on the go.",
  m095: "Apple App Store",
  m096: "iPhone & iPad",
  m097: "Dev & Learning",
  m098: "GizmoSQL Grafana Plugin Now Available on Grafana Marketplace",
  m099: "The GizmoSQL data source plugin for Grafana is now officially listed on the Grafana Marketplace. Connect Grafana directly to GizmoSQL using Arrow Flight SQL for high-performance observability dashboards.",
  m100: "Grafana Marketplace",
  m101: "Real-Time Dashboards",
  m102: "Token Authentication",
  m103: "GizmoSQL Now Available for Windows x64",
  m104: "GizmoSQL is now available as a native Windows installer (MSI) for x64 systems. Run terabyte-scale analytics on your Windows infrastructure at a fraction of the cost of cloud data warehouses.",
  m105: "Native Windows MSI Installer",
  m106: "x64 Architecture",
  m107: "Terabyte-Scale Analytics",
  m108: "90% Cost Savings",
  m109: "GizmoSQL Power BI Connector Now Available",
  m110: "Connect Microsoft Power BI directly to GizmoSQL with our new custom connector. Build interactive dashboards and reports powered by GizmoSQL's high-performance Arrow Flight SQL engine.",
  m111: "Native Power BI Integration",
  m112: "Arrow Flight SQL Protocol",
  m113: "Interactive Dashboards",
  m114: "Enterprise Ready",
  m115: "Philip Moore Spoke at DuckDB Developer Meeting #1",
  m116: "GizmoData founder Philip Moore presented \"GizmoEdge: A distributed DuckDB engine for IoT\" at the inaugural DuckDB Developer Meeting in Amsterdam.",
  m117: "Pakhuis de Zwijger, Amsterdam",
  m118: "GizmoSQL Enterprise Edition Now Available",
  m119: "Introducing GizmoSQL Enterprise Edition with advanced features for production deployments including session instrumentation and the KILL SESSION command.",
  m120: "OAuth / SSO Authentication",
  m121: "Session Instrumentation & Auditing",
  m122: "KILL SESSION Command",
  m123: "Catalog-Level Permissions",
  m124: "Priority Support",
  m125: "GizmoSQL v1.15.1: Native Geospatial Support",
  m126: "GizmoSQL now includes built-in support for geospatial data with GEOMETRY types, 100+ spatial functions, GeoArrow export, and seamless GeoPandas integration.",
  m127: "GEOMETRY Type",
  m128: "100+ Spatial Functions",
  m129: "GeoArrow Export",
  m130: "GeoPandas Integration",
  m131: "GizmoEdge Hits #1 on Hacker News",
  m132: "\"A sharded DuckDB on 63 nodes runs 1T row aggregation challenge in 5 sec\" — GizmoEdge's one-trillion-row challenge result, submitted by database performance legend Tanel Poder — climbed to the #1 spot on Hacker News, earning 224 points and a 136-comment technical discussion.",
  m133: "#1 on Hacker News",
  m134: "224 Points",
  m135: "136 Comments",
  m136: "1T Rows in 5 Seconds",
  m137: "Latest News",
  m138: "Stay up to date with GizmoData announcements, events, and product updates",
  m139: "Learn More",
  m140: "View All News",
  learnMoreAria: "Learn more",
};
export type Messages = typeof en;
export const messages = { en, 'pt-BR': {
  m000: "GizmoData Cloud já está disponível ao público: DuckDB totalmente gerenciado na AWS, Google Cloud e Azure",
  m001: "O GizmoData Cloud, o GizmoSQL totalmente gerenciado, agora está aberto a todos em app.gizmodata.com. Crie clusters Arrow Flight SQL baseados em DuckDB, catálogos DuckLake e consultas federadas na AWS, Google Cloud e Azure a partir de um único plano de controle, com planos pré-pagos a partir de US$ 29/mês que retornam integralmente como crédito de computação. Comece grátis com US$ 25 de crédito de lançamento, aplicado automaticamente, sem cartão de crédito.",
  m002: "AWS, Google Cloud e Azure",
  m003: "Catálogos DuckLake",
  m004: "Consultas federadas (14 drivers ADBC)",
  m005: "US$ 25 de crédito de lançamento, sem cartão",
  m006: "GizmoSQL v1.39.0: métricas Prometheus e execução imediata de DDL/DML",
  m007: "O GizmoSQL v1.39.0 adiciona métricas Prometheus na edição Enterprise — um endpoint /metrics opcional e a função SQL gizmosql_metrics(), que abrangem consultas, sessões, filas e recursos do processo, com um dashboard Grafana pronto e regras de alerta. DDL e DML agora são executados quando um cliente solicita a execução, para que uma gravação nunca se perca quando um driver deixa de buscar seu resultado. A versão também traz logs de ingestão em lote no nível INFO e bloqueios mais restritos no servidor para maior concorrência.",
  m008: "Endpoint /metrics do Prometheus",
  m009: "Monitoramento SQL com gizmosql_metrics()",
  m010: "Dashboard e alertas Grafana",
  m011: "Execução imediata de DDL/DML",
  m012: "Chris Wones entra na GizmoData como conselheiro estratégico",
  m013: "Chris Wones, líder de dados empresariais e engenharia com 34 anos de carreira na James River, Retek, dunnhumby e Kroger/84.51°, entrou na GizmoData como conselheiro estratégico. Ele traz ao GizmoSQL e ao GizmoData Cloud a visão de quem contrata plataformas de dados empresariais.",
  m014: "34 anos em dados empresariais",
  m015: "Oracle Big Data Leader do ano",
  m016: "Ex-executivo de engenharia",
  m017: "Kroger / 84.51° e dunnhumby",
  m018: "Servidor MCP do GizmoSQL: consulte o GizmoSQL pelo Claude Desktop e Claude Code",
  m019: "Lançamos o gizmosql-mcp, um servidor Model Context Protocol e uma extensão do Claude Desktop para o GizmoSQL. Claude Desktop, Claude Code e qualquer cliente MCP podem explorar seu esquema e executar SQL em um servidor GizmoSQL — somente leitura por padrão, com limites de linhas e de tempo impostos pelo servidor, credenciais mantidas no cofre de chaves do sistema operacional e suporte a vários servidores na mesma conversa. Gratuito, Apache-2.0.",
  m020: "Extensão do Claude Desktop",
  m021: "Pronto para Claude Code",
  m022: "Somente leitura por padrão",
  m023: "Vários servidores",
  m024: "A linha de drivers ADBC da GizmoData: Oracle, Db2, GizmoSQL e Quack",
  m025: "Lançamos drivers ADBC em Go puro, instaláveis com pip, para Oracle (sem Instant Client), IBM Db2 (sem CLI/JCC) e Quack do DuckDB, junto com nosso principal driver, o do GizmoSQL. Como todos são nativos de Apache Arrow, mover uma tabela de Oracle ou Db2 para o GizmoSQL exige poucas linhas de Python ou uma única instrução SQL no DuckDB — em ambas as direções.",
  m026: "Go puro, instalação via pip",
  m027: "Sem Instant Client / CLI / JCC",
  m028: "Oracle e Db2 ↔ GizmoSQL",
  m029: "Bidirecional via adbc_scanner",
  m030: "Driver ADBC do GizmoSQL 2.0: núcleo em Go, todas as linguagens ADBC",
  m031: "O driver ADBC do GizmoSQL foi refeito em Go com uma camada Python leve que mantém a compatibilidade direta com a versão 1.x. OAuth/SSO, detecção automática de DDL/DML e os demais recursos do GizmoSQL agora chegam a Python, Go, R, Rust, C#, C/C++ e JavaScript — e todo o ecossistema de clientes (dbt, SQLMesh, qgizmosql, sqlframe e o cliente Node.js por trás do GizmoSQL UI) foi atualizado para acompanhar.",
  m032: "Núcleo em Go",
  m033: "Python 2.0 com compatibilidade direta",
  m034: "OAuth / SSO em todas as linguagens",
  m035: "7 linguagens, 1 driver",
  m036: "GizmoSQL v1.34.0: atualização para Apache Arrow 25",
  m037: "O GizmoSQL v1.34.0 avança duas versões do Apache Arrow para a v25.0.0 — com fundamentos do protocolo Flight SQL, validação IPC mais rigorosa, o novo modelo formal de segurança do Arrow, uma stack gRPC/protobuf atualizada e acelerações ARM64 SVE no Graviton. Também inclui uma linha do tempo completa da execução de cada consulta na instrumentação Enterprise.",
  m038: "Apache Arrow 25.0.0",
  m039: "Formato de transmissão reforçado",
  m040: "Acelerações ARM64 SVE",
  m041: "Linha do tempo completa da consulta",
  m042: "Driver ADBC Python v1.2.0: perfis de conexão",
  m043: "O adbc-driver-gizmosql v1.2.0 adiciona suporte a perfis de conexão ADBC — arquivos TOML reutilizáveis que reúnem a URI e as opções do servidor GizmoSQL, com substituição por variáveis de ambiente para manter as credenciais fora do código. Alterne entre desenvolvimento e produção mudando apenas o nome do perfil.",
  m044: "Perfis TOML",
  m045: "Segredos em variáveis de ambiente",
  m046: "URIs profile://",
  m047: "Padrão entre linguagens",
  m048: "Participe da nova comunidade GizmoData no Slack",
  m049: "A GizmoData acaba de lançar uma comunidade no Slack onde usuários do GizmoSQL podem conversar diretamente com o fundador, trocar dicas sobre como executar DuckDB como servidor Apache Arrow Flight SQL, obter ajuda e saber primeiro dos novos lançamentos. A participação é gratuita e aberta a todos.",
  m050: "Fale com o fundador",
  m051: "Obtenha ajuda",
  m052: "Novidades de versões",
  m053: "Participação gratuita",
  m054: "Philip Moore no podcast A/I Prosperity",
  m055: "Philip Moore, fundador da GizmoData, conversou com Torben Andersen no podcast A/I Prosperity sobre GizmoSQL, a execução de DuckDB como servidor Apache Arrow Flight SQL de nível empresarial e a redução de custos de data warehouses na nuvem.",
  m056: "Philip Moore",
  m057: "GizmoSQL agora é um driver integrado ao DBeaver",
  m058: "A partir da versão 26.1.0, o GizmoSQL vem como driver nativo no DBeaver — a interface gráfica de banco de dados mais popular do mundo. Sem configuração manual de JDBC: escolha GizmoSQL na lista de drivers, informe sua conexão e comece a consultar. Incluído e mantido no projeto oficial.",
  m059: "Driver integrado",
  m060: "DBeaver 26.1.0+",
  m061: "Sem configuração de JDBC",
  m062: "Arrow Flight SQL",
  m063: "Driver JDBC experimental para Quack",
  m064: "Um novo driver JDBC para o protocolo remoto Quack — aponte qualquer ferramenta JVM (DBeaver, DataGrip, dbt, Spark) para uma URL jdbc:quack:// e comece a consultar um servidor DuckDB remoto. Distribuído no Maven Central. Experimental/alpha.",
  m065: "URLs jdbc:quack://",
  m066: "Compatível com ferramentas JVM",
  m067: "Decodificação de DataChunk",
  m068: "Maven e JAR direto",
  m069: "Driver ADBC experimental para Quack",
  m070: "Um novo driver Apache Arrow ADBC para o protocolo remoto Quack — RecordBatches Arrow sem cópia, diretamente de um servidor DuckDB remoto. Disponível para Python (PyPI) e Go (pkg.go.dev), com suporte a streaming e ingestão em lote. Experimental/alpha.",
  m071: "Arrow sem cópia",
  m072: "Python e Go",
  m073: "Ingestão em lote",
  m074: "Resultados em streaming",
  m075: "GizmoSQL agora tem uma biblioteca Python",
  m076: "Inicie um servidor GizmoSQL real a partir de Python em duas linhas — ideal para fixtures de pytest, fluxos com vários agentes e demonstrações em notebooks. A biblioteca gerencia um subprocesso do servidor em uma porta livre e baixa o binário correspondente no primeiro uso. Instale com `pip install gizmosql[adbc]`.",
  m077: "pip install gizmosql[adbc]",
  m078: "Gerenciador de contexto Server()",
  m079: "Pronto para fixtures de pytest",
  m080: "Canais estável e LTS",
  m081: "Apresentamos o canal LTS do GizmoSQL",
  m082: "O GizmoSQL agora tem dois canais de lançamento paralelos — Stable (versão secundária mais recente do DuckDB) e LTS (versão LTS mais recente do DuckDB) — para implantações em produção que precisam de um mecanismo com mudanças mais graduais e suporte prolongado. Os mesmos recursos do GizmoSQL, o mesmo protocolo e instalações lado a lado.",
  m083: "Acompanha as versões LTS do DuckDB",
  m084: "Stable e LTS lado a lado",
  m085: "API GizmoSQL idêntica",
  m086: "Homebrew, Docker e MSI",
  m087: "qgizmosql: novo plugin QGIS para GizmoSQL",
  m088: "Explore e visualize dados espaciais de um servidor GizmoSQL diretamente no QGIS. Conecte-se a um serviço GizmoSQL Arrow Flight SQL remoto ou local, escolha uma tabela e adicione-a como camada QGIS — sem precisar de um arquivo DuckDB bruto.",
  m089: "Transporte Arrow Flight SQL",
  m090: "Remoto e multiusuário",
  m091: "Senha ou OAuth/SSO",
  m092: "Mecanismo espacial no servidor",
  m093: "GizmoSQL agora está disponível na Apple App Store",
  m094: "O GizmoSQL agora está na Apple App Store para iPhone e iPad. Inicie um servidor Arrow Flight SQL real na palma da mão — ideal para desenvolvimento, experimentação e aprendizado em qualquer lugar.",
  m095: "Apple App Store",
  m096: "iPhone e iPad",
  m097: "Desenvolvimento e aprendizado",
  m098: "Plugin Grafana do GizmoSQL disponível no Grafana Marketplace",
  m099: "O plugin de fonte de dados GizmoSQL para Grafana agora está oficialmente listado no Grafana Marketplace. Conecte o Grafana diretamente ao GizmoSQL usando Arrow Flight SQL para dashboards de observabilidade de alto desempenho.",
  m100: "Grafana Marketplace",
  m101: "Dashboards em tempo real",
  m102: "Autenticação por token",
  m103: "GizmoSQL agora está disponível para Windows x64",
  m104: "O GizmoSQL agora está disponível como instalador nativo Windows (MSI) para sistemas x64. Execute análises de terabytes na sua infraestrutura Windows por uma fração do custo de data warehouses na nuvem.",
  m105: "Instalador MSI nativo para Windows",
  m106: "Arquitetura x64",
  m107: "Análise de dados em escala de terabytes",
  m108: "Economia de custos de 90%",
  m109: "Conector Power BI do GizmoSQL já disponível",
  m110: "Conecte o Microsoft Power BI diretamente ao GizmoSQL com nosso novo conector personalizado. Crie dashboards e relatórios interativos com o mecanismo Arrow Flight SQL de alto desempenho do GizmoSQL.",
  m111: "Integração nativa com Power BI",
  m112: "Protocolo Arrow Flight SQL",
  m113: "Dashboards interativos",
  m114: "Pronto para empresas",
  m115: "Philip Moore palestrou no DuckDB Developer Meeting #1",
  m116: "Philip Moore, fundador da GizmoData, apresentou \"GizmoEdge: um mecanismo DuckDB distribuído para IoT\" no primeiro DuckDB Developer Meeting, em Amsterdã.",
  m117: "Pakhuis de Zwijger, Amsterdã",
  m118: "GizmoSQL Enterprise Edition já disponível",
  m119: "Apresentamos a edição Enterprise do GizmoSQL, com recursos avançados para implantações em produção, incluindo instrumentação de sessões e o comando KILL SESSION.",
  m120: "Autenticação OAuth / SSO",
  m121: "Instrumentação e auditoria de sessões",
  m122: "Comando KILL SESSION",
  m123: "Permissões por catálogo",
  m124: "Suporte prioritário",
  m125: "GizmoSQL v1.15.1: suporte geoespacial nativo",
  m126: "O GizmoSQL agora inclui suporte nativo a dados geoespaciais com tipos GEOMETRY, mais de 100 funções espaciais, exportação GeoArrow e integração fluida com GeoPandas.",
  m127: "Tipo GEOMETRY",
  m128: "Mais de 100 funções espaciais",
  m129: "Exportação GeoArrow",
  m130: "Integração GeoPandas",
  m131: "GizmoEdge alcança o 1º lugar no Hacker News",
  m132: "\"DuckDB fragmentado em 63 nós executa o desafio de agregação de 1 trilhão de linhas em 5 segundos\" — o resultado do desafio de um trilhão de linhas do GizmoEdge, publicado pela referência em desempenho de bancos de dados Tanel Poder — chegou ao 1º lugar no Hacker News, com 224 pontos e uma discussão técnica de 136 comentários.",
  m133: "1º lugar no Hacker News",
  m134: "224 pontos",
  m135: "136 comentários",
  m136: "1 trilhão de linhas em 5 segundos",
  m137: "Últimas notícias",
  m138: "Acompanhe anúncios, eventos e atualizações de produtos da GizmoData",
  m139: "Saiba mais",
  m140: "Ver todas as notícias",
  learnMoreAria: "Saiba mais",
} satisfies Messages };
